import { IonIcon } from '@ionic/react';
import { warningOutline } from 'ionicons/icons';
import { useNewsModal } from '../../hooks/NewsHooks';
import { NewsView } from '../../model/models';
import { Modal } from '../globals/Modal';
import { SanitizeHTML } from '../globals/SanitizeHTML';
import { NewsModalContent } from './NewsModalContent';

export const NewsItemSimple = (
  news: NewsView,
  baseUrl: string,
  key: number
) => {
  const { authorImgUrl, houseName, differenceTime } = useNewsModal(news);

  const alertClass = news.alert ? 'p-4 bg-funkyPink rounded-xl' : '';
  const alertClassText = news.alert ? 'text-white' : 'text-black';

  return (
    <div className={`mb-6 font-normal text-sm ${alertClass}`} key={key}>
      <Modal
        content={
          <NewsModalContent
            news={news}
            differenceTime={differenceTime}
            authorImgUrl={authorImgUrl}
            houseName={houseName}
          />
        }
        ModalUrl={baseUrl + '/' + news.slug}
        backUrl={baseUrl}
      >
        <div className="relative ">
          <SanitizeHTML
            tag="h2"
            className={`font-semibold text-base mb-2 w-11/12 ${alertClassText}`}
            html={news.title}
          />
          {news.alert && (
            <IonIcon
              className="text-white text-xl leading-none absolute top-0 right-0"
              icon={warningOutline}
              color="light"
            />
          )}
          <p className={`font-normal text-xs opacity-75 ${alertClassText}`}>
            {differenceTime}
          </p>
        </div>
      </Modal>
    </div>
  );
};
